import {IFaceMatch } from '../@types/FaceMatch';
import { useEffect,useState } from 'react';
import { useCopyToClipboard } from 'usehooks-ts'
import axios from "axios";

type IProps = {
  face: IFaceMatch;
  imgWidth: string,
  imgHeight: string,
  showLastSeen?: boolean,
}

const FaceComponent: React.FC<IProps> = (props:IProps) => {

  const [showLastSeen, setShowLastSeen] = useState(true);
  const [copiedText, copy] = useCopyToClipboard();
  const [currentPersonUrl, setPersonUrl] = useState('');
  const [currentShareUrl, setShareUrl] = useState('');
  const [currentThumbnailUrl, setThumbnailUrl] = useState('');
  const [lastSeenstr, seLastSeenstr] = useState('');
  const [siteICO, setSiteICO] = useState('');
  const [numberOfImages, setNumberOfImages] = useState(0);
  

  useEffect(()=>{
    if(props.showLastSeen === undefined) 
      setShowLastSeen(true);
    else
      setShowLastSeen(props.showLastSeen);
    seLastSeenstr(date_TO_String(new Date(props.face.lastSeen)));
    seLastSeenstr(props.face.lastSeenMsg);
    setThumbnailUrl(props.face.thumbnailUrl);
    setPersonUrl(props.face.personUrl);
    setShareUrl('https://www.camgirlcrawler.net/model/' + props.face.siteCode + '/' + props.face.name);
    setSiteICO('images/' + props.face.siteCode + '.webp');
    setNumberOfImages(props.face.numberOfImages);
}, []); // empty array means only once

  async function handleImageError(e:any){
    axios
    .get(props.face.thumbnailUrl,{responseType:"blob",timeout: 5000})
    .then((resp) => {
      if(resp.data.type==='image/jpeg'){
        setThumbnailUrl(props.face.thumbnailUrl);
        e.target.src = props.face.thumbnailUrl;
      }else{
        setThumbnailUrl('images/unknown.gif');
        e.target.src = 'images/unknown.gif';
      }
    })
    .catch(() => {
      setThumbnailUrl('images/unknown.gif');
      console.clear();
    });
   }  

   function date_TO_String(date_Object: Date): string {
    let date_String: string =
      date_Object.getDate() +
      "/" +
      (date_Object.getMonth() + 1) +
      "/" +
      +date_Object.getFullYear();
    return date_String;
  }

  const handleCopy = (text: string) => async () => {
    await copy(text)
      .then(() => {
        console.log('Copied!', { text })
        alert(`${text} copied to clipboard!`);
      })
      .catch(error => {
        //console.error('Failed to copy!', error)
        console.clear();
      })
  }

  function openInNewTab(url:string){
    window.open(url, "_blank", "noreferrer");
  };

  function openMorePicsInNewTab(siteCode:string,name:string){
    window.open("/model/"+siteCode+"/"+name);
  };

return (
    <div className="results">
      <div>
            <div className='thumb' role="link" onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}}>
              <div className='thumbInner'>
              <div className={(props.face.isOnline ? 'onlineShow' : 'onlineHide')}>ONLINE</div>
              <div className={(props.face.hotDealPercent === 0 ? 'hotDealHide' : 'hotDealShow')}>{props.face.hotDealPercent}% OFF</div>
                <img onError={(e) => handleImageError(e)} src={`${currentThumbnailUrl}`}  width={props.imgWidth} height={props.imgHeight} alt={`Click to visit camgirl ${props.face.name}`} title={`Click to visit camgirl ${props.face.name}`} />
              </div>     
            </div>
            <div>              
              <span>
                <img src={`${siteICO}`} alt={`${props.face.site}`} title={`${props.face.site}`}  width={16} height={16}/>
                &nbsp;&nbsp;<span onClick={() => openInNewTab(currentPersonUrl)} style={{cursor:'pointer'}} title={`Click to visit camgirl ${props.face.name}`} data-toggle="tooltip">{props.face.name}</span>&nbsp;
                {Number(props.face.certainty) > 0 && (   
                  <span>
                      {Number(props.face.certainty) <= 41 && ( 
                        <img src={'images/red_dot.webp'} alt={`${props.face.certainty}% likely is same camgirl`}  title={`${props.face.certainty}% likely is same camgirl`}  width={16} height={16} style={{cursor:'pointer',marginLeft:'3px'}}/>
                      )}
                      {Number(props.face.certainty) > 41 && Number(props.face.certainty) < 55 && ( 
                        <img src={'images/amber_dot.webp'} alt={`${props.face.certainty}% likely is same camgirl`} title={`${props.face.certainty}% likely is same camgirl`} width={16} height={16} style={{cursor:'pointer',marginLeft:'3px'}}/>
                      )}
                      {Number(props.face.certainty) >= 55 && ( 
                        <img src={'images/green_dot.webp'} alt={`${props.face.certainty}% likely is same camgirl`}  title={`${props.face.certainty}% likely is same camgirl`} width={16} height={16} style={{cursor:'pointer',marginLeft:'3px'}}/>
                      )}
                  </span>
                  )}
                </span><br/>
              {showLastSeen && (
                  <span>Seen: {lastSeenstr}
                       { numberOfImages > 1 ? (
                          <img onClick={() => openMorePicsInNewTab(props.face.siteCode,props.face.name)} src={'images/goto.webp'} alt={`Click to see more of ${props.face.name}`} title={`Click to see more of ${props.face.name}`}  width={16} height={16} style={{cursor:'pointer',marginLeft:'5px'}}/>
                        ):(
                          <img src={'images/goto_grey.png'} alt={`No more face images of ${props.face.name}`} title={`No more face images of ${props.face.name}`} width={16} height={16} style={{cursor:'pointer',marginLeft:'5px'}}/> 
                        )}
                         <img onClick={handleCopy(currentShareUrl)} src={'images/share.png'}  alt='Copy link to clipboard' title='Copy link to clipboard' width={16} height={16} style={{cursor:'pointer',marginLeft:'5px'}}/>
                  </span>
              )}
            </div>  
    </div>
  </div>
  );
}
export default FaceComponent;